import * as React from 'react'
import { css } from '@emotion/react'

import Stack from '@mui/material/Stack'
import { styled } from '@mui/material/styles'

import { I18n, useTranslation } from 'components/hooks/use-translation'
import Button from 'components/atomic/atoms/button'
import Text from 'components/atomic/atoms/text'

import { PathGoal } from 'types/types'

const CtaCard = styled('div')`
    position: relative;
    border-radius: ${({ theme }) => theme.shape.borderRadius}px;
    border: ${({ theme }) => `1px solid ${theme.palette.divider}`};
`

const BackgroundImage = styled('div')<{ type?: PathGoal }>`
    background: url('/assets/lines2.png');
    background-repeat: no-repeat;
    background-position: right;
    background-size: cover;
    position: absolute;
    height: 100%;
    width: 100%;
    z-index: -1;
    opacity: 0.7;

    ${({ type }) => {
        if (type === 'career') {
            return css`
                filter: invert(61%) sepia(4%) saturate(7137%) hue-rotate(314deg) brightness(91%) contrast(100%);
            `
        }

        if (type === 'skill') {
            return css`
                filter: invert(67%) sepia(17%) saturate(5877%) hue-rotate(190deg) brightness(95%) contrast(91%);
            `
        }

        if (type === 'course') {
            return css`
                filter: invert(69%) sepia(52%) saturate(5228%) hue-rotate(242deg) brightness(93%) contrast(95%);
            `
        }
    }}

    ${({ theme }) => theme.breakpoints.down('md')} {
        opacity: 0.5;
    }
`

const CtaContent = styled('div')`
    flex: 1;
    ${({ theme }) => theme.breakpoints.up('md')} {
        max-width: 50%;
    }
`

const CTASimple = (props: { type?: PathGoal }) => {
    const { t }: I18n = useTranslation()

    const handleClick = () => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth',
        })
    }

    return (
        <CtaCard>
            <BackgroundImage type={props.type} />
            <Stack m={3} direction="row" justifyContent="space-between" alignItems="flex-end">
                <CtaContent>
                    <Stack spacing="1rem">
                        <Text variant="h4">{t('path:methodSection.ctaTitle')}</Text>
                        <Text color="text.secondary">{t('path:methodSection.ctaDescription')}</Text>
                    </Stack>
                </CtaContent>
                <Button onClick={handleClick} size="large" variant="contained">
                    {t('path:buttons.enroll')}
                </Button>
            </Stack>
        </CtaCard>
    )
}

export default CTASimple
